export const API_URL = process.env.REACT_APP_BASE_URL;;

export const GET_TOP_DESTINATION_API = `${API_URL}/TopDestination/index`;
export const GET_TOP_DESTINATION_BY_ID_API = `${API_URL}/TopDestination/getById`;
export const CREATE_TOP_DESTINATION_API = `${API_URL}/TopDestination/create`;
export const DELETE_TOP_DESTINATION_API = `${API_URL}/TopDestination/delete`;
export const UPDATE_TOP_DESTINATION_API = `${API_URL}/TopDestination/update`;

export const GET_CONTACT_LOCATIONS_API = `${API_URL}/ContactLocation/index`;
export const GET_CONTACT_LOCATION_BY_ID_API = `${API_URL}/ContactLocation/getById`;
export const CREATE_CONTACT_LOCATION_API = `${API_URL}/ContactLocation/create`;
export const DELETE_CONTACT_LOCATION_API = `${API_URL}/ContactLocation/delete`;
export const UPDATE_CONTACT_LOCATION_API = `${API_URL}/ContactLocation/update`;

export const GET_TRAVEL_PACKAGES_API = `${API_URL}/travelpackage`;
export const CREATE_TRAVEL_PACKAGE_API = `${API_URL}/travelpackage/create`;
export const UPDATE_TRAVEL_PACKAGE_API = `${API_URL}/travelpackage/update`;
export const DELETE_TRAVEL_PACKAGE_API = `${API_URL}/travelpackage/delete`;

export const GET_SERVICES_API = `${API_URL}/services/index`;
export const CREATE_SERVICE_API = `${API_URL}/services/create`;
export const UPDATE_SERVICE_API = `${API_URL}/services/update`;
export const DELETE_SERVICE_API = `${API_URL}/services/delete`;

export const GET_TESTIMONIALS_API = `${API_URL}/testimonial/index`
export const CREATE_TESTIMONIAL_API = `${API_URL}/testimonial/create`;
export const UPDATE_TESTIMONIAL_API = `${API_URL}/testimonial/update`;
export const DELETE_TESTIMONIAL_API = `${API_URL}/testimonial/delete`;

export const GET_CAROUSEL_API = `${API_URL}/imagecarousel/index`;
export const CREATE_CAROUSEL_API = `${API_URL}/imagecarousel/create`;
export const UPDATE_CAROUSEL_API = `${API_URL}/imagecarousel/update`;
export const DELETE_CAROUSEL_API = `${API_URL}/imagecarousel/delete`;

export const CREATE_CONTACT_MESSAGE_API = `${API_URL}/ContactMessage/create`;